<template>
  <div class="kfkc_tj">
    <div>
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="center"
            label-width="100px"
          >
            <el-form-item label="仓库名称:">
              <el-select
                v-model="searchForm.ckId"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in cfckkv"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="统计日期:" style="">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  clearable
                  value-format="yyyy-MM-dd"
                  :picker-options="startTime"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                  clearable
                  value-format="yyyy-MM-dd"
                  :picker-options="endTime"
                />
              </el-col>
            </el-form-item>

            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              size="small"
              round
              type="primary"
              @click="getHomeList"
            >搜索</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 51px;
        "
      >
        <div class="tablemes">
          <el-alert
            title="默认统计近一年的数据"
            :closable="false"
            type="warning"
            center
          />
          <el-table
            ref="cktable"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, i) in table"
              :key="i"
              :show-overflow-tooltip="true"
              align="center"
              :label="item.label"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row[item.key] }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getkfkcList, getckList } from '@/assets/js/tjbb.js'

export default {
  components: {},
  props: {},
  data() {
    return {
      startTime: {
        disabledDate: (time) => {
          if (this.searchForm.endTime) {
            return time.getTime() > new Date(this.searchForm.endTime).getTime() || time.getTime() < 1640966400000
          } else {
            return time.getTime() > Date.now() || time.getTime() < 1640966400000
          }
        }
      },
      endTime: {
        disabledDate: (time) => {
          if (this.searchForm.beginTime) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() < new Date(this.searchForm.beginTime).getTime() - 86400000
            )
          } else {
            return time.getTime() > Date.now() || time.getTime() < 1640966400000
          }
        }
      },

      cfckkv: [],
      pupopShow: false,
      searchForm: {
        ckId: '',
        beginTime: '',
        endTime: ''
      },
      table: [
        {
          key: 'ckmc',
          label: '仓库名称'
        },
        // 接口没有数据
        // {
        //   key: "cgyxm",
        //   label: "仓管员姓名"
        // },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },
        {
          key: 'qcSl',
          label: '期初数量'
        },
        {
          key: 'qmSl',
          label: '期末数量'
        }
      ],
      tableData: [
        {
          ckmc: '1号仓库',
          cgyxm: '张三',
          hxp: '盐酸',
          cqsl: '150升',
          qmsl: '150升'
        }
      ], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10 // 每页的数据条数
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.ckmckvfunc()
    this.getHomeList()
  },
  created() {},

  beforeDestroy() {},
  methods: {
    // 仓库名称
    ckmckvfunc() {
      getckList().then((res) => {
        this.cfckkv = res.data.data
      })
    },
    // 获取库房库存统计列表
    getHomeList() {
      getkfkcList(this.searchForm).then((res) => {
        this.tableData = res.data.data
      })
    },
    addPupShow() {
      this.$refs.cangchuCk.dialogVisible = true
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 7) {
        switch (row.zt) {
          case '已出库':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '已出库,变更申请中':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '草稿':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    }
  }
}
</script>
<style scoped lang="less">
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.kfkc_tj {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
